"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownAlgorithmError = void 0;
/**
 * Thrown when a verifier/signer is created with an unknown algorithm
 */
class UnknownAlgorithmError extends Error {
}
exports.UnknownAlgorithmError = UnknownAlgorithmError;
//# sourceMappingURL=unknown-algorithm-error.js.map